export enum SegmentPropertyValue {
  CHECKOUT_PAGE = 'checkout_page',
  CHECKOUT_EMAIL = 'checkout_email',
  MANUAL_INVITE = 'manual_invite',
  STARTED = 'started',
  ONLINE_WILL = 'online_will',
  COMPLETE = 'complete',
  PROFESSIONAL_EXECUTOR = 'professional_executor'
}
